export default __webpack_public_path__ + "static/media/info.1a6a02bd.svg";